import { Component, Input } from '@angular/core';
import { slideDownFromTopAnimation, slideUpToTopAnimation } from '../transitions/slide-down-animation';
import { transition, trigger, useAnimation } from '@angular/animations';
import { ScreenShareService } from '../services/screen-share.service';

@Component({
  selector: 'edportal-screen-share-banner',
  standalone: false,
  templateUrl: './screen-share-banner.component.html',
  styles: `
    .screen-share-banner {
      z-index: 10000;
      position: relative;
    }
  `,
  animations: [
    trigger('slideDown', [
      transition(':enter', [
        useAnimation(slideDownFromTopAnimation, {
          params: { time: '0.5s' },
        }),
      ]),
      transition(':leave', [
        useAnimation(slideUpToTopAnimation, {
          params: { time: '0.5s' },
        }),
      ]),
    ]),
  ],
})
export class ScreenShareBannerComponent {
  @Input() requesterEmail: string | null = null;

  constructor(private readonly screenShareService: ScreenShareService) {}

  async acceptRequest() {
    await this.screenShareService.acceptScreenShare(this.requesterEmail!);
  }

  async declineRequest() {
    await this.screenShareService.declineScreenShare(this.requesterEmail!);
  }
}
